export class DeclarationType {
    id: number;
    name: string;
    distance: boolean;
    unit_price: number;
}
